<!--LOAD MODAL DIALOG MASK-->
<div #modalDialog class="modal-background-mask" style="display: none" id="{{ containerID }}">
  <!--LOAD MODAL CONTAINER-->
  <section class="modal-dialog" [ngClass]="modalMaxWidth ? modalMaxWidth : ''">
    <!--CLOSE MODAL ICON BUTTON-->
    <div class="modal-controls">
      <a class="modal-close" href="javascript:void(0)" (click)="closeModal()">
        <i class="icon small plus black left"></i>
      </a>
    </div>
    <!--END CLOSE MODAL ICON BUTTON-->

    <!--LOAD MODAL BODY CONTENT-->
    <div class="modal-body">
      <!--NOTE: Allow ng-content or another block of elements to be projected into this modal-->
      <ng-content></ng-content>
    </div>
    <!--LOAD MODAL BODY CONTENT-->
  </section>
  <!--END LOAD MODAL CONTAINER-->
</div>
<!--END LOAD MODAL DIALOG MASK-->
